import React from "react";
import { ProvidersStatistics } from "../../models/Statistics/ProvidersStatistics";
import StatisticsCard from "../common/StatisticsCard";
import { CHART_COLORS } from "../../constants/ChartColors";

interface ProvidersStatisticsCardProps {
  statistics: ProvidersStatistics;
}

const ProvidersStatisticsCard: React.FC<ProvidersStatisticsCardProps> = ({
  statistics,
}) => {
  const providerChartData = [
    {
      name: "Migrated",
      value: statistics.providersMigrated,
      color: CHART_COLORS.migrated,
    },
    {
      name: "In Progress",
      value: statistics.providersInProgress,
      color: CHART_COLORS.inProgress,
    },
    {
      name: "Interrupted",
      value: statistics.providersInterrupted,
      color: CHART_COLORS.interrupted,
    },
    {
      name: "Not Started",
      value:
        statistics.numberOfProviders -
        (statistics.providersMigrated +
          statistics.providersInterrupted +
          statistics.providersInProgress +
          statistics.providersFlagged),
      color: CHART_COLORS.notStarted,
    },
    {
      name: "Flagged",
      value: statistics.providersFlagged,
      color: CHART_COLORS.flagged,
    },
  ];
  const filesChartData = [
    {
      name: "Migrated",
      value: statistics.filesMigrated,
      color: CHART_COLORS.migrated,
    },
    {
      name: "Not Found",
      value: statistics.filesNotFound,
      color: CHART_COLORS.inProgress,
    },
    {
      name: "Not Found (Marked For Retry)",
      value: statistics.filesNotFoundMarkedForRetry,
      color: CHART_COLORS.acknowledged,
    },
    {
      name: "Interrupted Initial",
      value: statistics.filesInterruptedInitial,
      color: CHART_COLORS.interrupted,
    },
    {
      name: "Interrupted Delta",
      value: statistics.filesInterruptedDelta,
      color: CHART_COLORS.interruptedDelta,
    },
    {
      name: "Modified",
      value: statistics.filesModified,
      color: CHART_COLORS.modified,
    },
    {
      name: "Not Started",
      value: Math.max(0,
        statistics.totalNumberOfFiles -
        (statistics.filesMigrated +
          statistics.filesInterruptedInitial +
          statistics.filesInterruptedDelta +
          statistics.filesModified +
          statistics.filesNotFound +
          statistics.filesNotFoundMarkedForRetry +
          statistics.filesFlagged +
          statistics.filesSkippedDuplicate +
          statistics.providerFilesUnresolvedConflictCount +
          statistics.providerFilesAcknowledgedConflictCount)),
      color: CHART_COLORS.notStarted,
    },
    {
      name: "Blocked by conflict",
      value: statistics.providerFilesUnresolvedConflictCount,
      color: CHART_COLORS.blockedByConflict,
    },
    {
      name: "Acknowledged conflict",
      value: statistics.providerFilesAcknowledgedConflictCount,
      color: CHART_COLORS.acknowledgedConflict,
    },
    {
      name: "Skipped Duplicate",
      value: statistics.filesSkippedDuplicate,
      color: CHART_COLORS.skippedDuplicate,
    },
  ];
  const flagsChartData = [
    {
      name: "Blocked by user",
      value: statistics.filesInProvidersBlockedByUser,
      color: CHART_COLORS.blockedByUser,
    }
  ];
  return (
    <StatisticsCard
      migrationChartData={{ data: providerChartData, label: "Providers" }}
      filesChartData={{ data: filesChartData, label: "Files" }}
      fileFlagsChartData={{ data: flagsChartData, label: "Flags"}}
      title={"Providers Statistics"}
      totalFilesSizeInGb={statistics.totalFilesSizeInGb}
      totalMigratedFilesSizeInGb={statistics.totalMigratedFilesSizeInGb}
      totalFilesSizeInMb={statistics.totalFilesSizeInMb}
      totalMigratedFilesSizeInMb={statistics.totalMigratedFilesSizeInMb}
      notFoundFilesSizeInGb={statistics.notFoundProviderFilesSizeInGb || 0}
      notFoundFilesSizeInMb={statistics.notFoundProviderFilesSizeInMb || 0}
      interruptedFilesSizeInGb={(statistics.interruptedInitialProviderFilesSizeInGb || 0) + (statistics.interruptedDeltaProviderFilesSizeInGb || 0)}
      interruptedFilesSizeInMb={(statistics.interruptedInitialProviderFilesSizeInMb || 0) + (statistics.interruptedDeltaProviderFilesSizeInMb || 0)}
      skippedDuplicateFilesSizeInGb={statistics.skippedDuplicateProviderFilesSizeInGb || 0}
      skippedDuplicateFilesSizeInMb={statistics.skippedDuplicateProviderFilesSizeInMb || 0}
      showFlaggedSizeInfo={false}
    />
  );
};

export default ProvidersStatisticsCard;
